/* =========================================================
   GMC — Back to Top Button
   Shows/hides the #gmc-back-top button based on scroll depth.
   The if (!btn) guard prevents errors on pages where the
   button element does not exist.
   ========================================================= */
(function() {
  var btn = document.getElementById('gmc-back-top');
  if (!btn) return;
  var threshold = 400;

  window.addEventListener('scroll', function() {
    if (window.scrollY > threshold) {
      btn.classList.add('visible');
    } else {
      btn.classList.remove('visible');
    }
  }, { passive: true });

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
